var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('Menu',{staticStyle:{"width":"300px","margin-top":"-7px"}}),_c('div',{staticClass:"sub-content"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }